//  DESKTOP + DRAWER FILTER AJAX (CLEAN + FIXED)

document.addEventListener("DOMContentLoaded", function () {

  const productGridWrapper = document.querySelector(".collection-grid__wrapper");
  const activeTagsWrapper = document.querySelector(".tag-list--active-tags");

  if (!productGridWrapper) return;

  /* Get all filter forms (desktop + drawer) */
  function getAllFilterForms() {
    return document.querySelectorAll(
      "#CollectionSidebar .filter-form, #FilterDrawer .filter-form"
    );
  }

  /* Debounce */
  let filterTimer = null;

  function applyFilters(form) {
    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => {
      const formData = new FormData(form);
      const params = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${params}`;
      loadFromURL(url);
    }, 250);
  }

  /* Bind all filter events */
  function bindFilterEvents() {
    getAllFilterForms().forEach((form) => {
      form.querySelectorAll("input[type='checkbox']").forEach((input) => {
        input.addEventListener("change", () => applyFilters(form));
      });
    });
  }
  bindFilterEvents();

  /* AJAX Load HTML */
  function loadFromURL(url) {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {

        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, "text/html");

        /* Update products */
        const newGrid = newDoc.querySelector(".collection-grid__wrapper");
        if (newGrid) productGridWrapper.innerHTML = newGrid.innerHTML;

        /* Update active tag pills */
        const newTags = newDoc.querySelector(".tag-list--active-tags");
        if (newTags && activeTagsWrapper)
          activeTagsWrapper.innerHTML = newTags.innerHTML;

        /* Sync sidebar + drawer checkboxes */
        updateAllSidebarAndDrawerStates(newDoc);

        /* Update URL */
        history.replaceState({}, "", url);

        /* Rebind events */
        bindFilterEvents();

        /* Fix drawer not opening again */
        fixDrawerRebind();
      });
  }

  /* Update states (desktop + drawer) */
  function updateAllSidebarAndDrawerStates(newDoc) {
    const oldSidebar = document.querySelector("#CollectionSidebar");
    const newSidebar = newDoc.querySelector("#CollectionSidebar");

    if (!oldSidebar || !newSidebar) return;

    oldSidebar.querySelectorAll("input[type='checkbox']").forEach((input) => {
      const name = input.name;
      const value = input.value;
      const li = input.closest("li");

      const newInput = newSidebar.querySelector(
        `input[name="${name}"][value="${value}"]`
      );

      if (newInput?.checked) {
        input.checked = true;
        li?.classList.add("tag--active");
      } else {
        input.checked = false;
        li?.classList.remove("tag--active");
      }
    });

    /* Sync drawer too */
    const drawer = document.querySelector("#FilterDrawer");
    const newDrawer = newDoc.querySelector("#FilterDrawer");

    if (drawer && newDrawer) {
      drawer.querySelectorAll("input[type='checkbox']").forEach((input) => {
        const name = input.name;
        const value = input.value;
        const li = input.closest("li");

        const newInput = newDrawer.querySelector(
          `input[name="${name}"][value="${value}"]`
        );

        if (newInput?.checked) {
          input.checked = true;
          li?.classList.add("tag--active");
        } else {
          input.checked = false;
          li?.classList.remove("tag--active");
        }
      });
    }
  }

  /* FIX: drawer button stops working after AJAX */
  function fixDrawerRebind() {
    const drawer = document.getElementById("FilterDrawer");
    const openButtons = document.querySelectorAll(".js-drawer-open-collection-filters");
    const closeButton = drawer?.querySelector(".js-drawer-close");

    openButtons.forEach(btn => {
      btn.onclick = function(e) {
        e.preventDefault();
        drawer.classList.add("is-open");
        document.body.classList.add("drawer-open");
      };
    });

    closeButton.onclick = function () {
      drawer.classList.remove("is-open");
      document.body.classList.remove("drawer-open");
    };
  }

  /* INITIAL drawer binding */
  fixDrawerRebind();

});

// Mobile
document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.getElementById("FilterDrawer");
  if (!drawer) return;

  const openButtons = document.querySelectorAll(".js-drawer-open-collection-filters");
  const closeButton = drawer.querySelector(".js-drawer-close");

  openButtons.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      drawer.classList.add("is-open");
      document.body.classList.add("drawer-open");
    });
  });

  closeButton.addEventListener("click", function () {
    drawer.classList.remove("is-open");
    document.body.classList.remove("drawer-open");
  });

});

/* -------------------------
   Replace applyFilters() + loadFromURL()
   ------------------------- */

function buildShopifyQueryFromForm(form) {
  // Collect all checked checkboxes across all filter forms (so combinations work)
  const allChecked = Array.from(document.querySelectorAll("#CollectionSidebar .filter-form input[type='checkbox']:checked, #FilterDrawer .filter-form input[type='checkbox']:checked"));

  // Also keep current sort_by if present in the page
  const sortSelect = document.querySelector('#SortBy');
  const sortByValue = sortSelect ? sortSelect.value : null;

  const pairs = [];

  // Build pairs from checked inputs
  allChecked.forEach(input => {
    const name = input.name;
    const rawValue = input.value;

    // encode value and convert %20 -> + (Shopify expects + for spaces)
    const encoded = encodeURIComponent(rawValue).replace(/%20/g, '+');

    pairs.push(`${encodeURIComponent(name)}=${encoded}`);
  });

  // Add sort_by if present
  if (sortByValue) {
    pairs.push(`sort_by=${encodeURIComponent(sortByValue)}`);
  }

  // If you need page param to be removed, ensure not included
  // (we are not adding page param here)
  return pairs.length ? pairs.join('&') : '';
}

function applyFilters(form) {
  // Debounce already handled by outer logic — if you still use debounce, keep it.
  const qs = buildShopifyQueryFromForm(form);
  const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  loadFromURL(url);
}

function loadFromURL(url) {
  fetch(url)
    .then(res => {
      if (!res.ok) throw new Error('Network response not ok');
      return res.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      /* UPDATE PRODUCT GRID */
      const newGrid = newDoc.querySelector('.collection-grid__wrapper');
      if (newGrid) productGridWrapper.innerHTML = newGrid.innerHTML;

      /* UPDATE ACTIVE TAGS */
      const newTags = newDoc.querySelector('.tag-list--active-tags');
      if (newTags && activeTagsWrapper) activeTagsWrapper.innerHTML = newTags.innerHTML;

      /* UPDATE SIDEBAR + DRAWER STATES */
      updateAllSidebarAndDrawerStates(newDoc);

      /* UPDATE URL (so refresh shows same state) */
      history.replaceState({}, '', url);

      /* REBIND FILTER EVENTS */
      bindFilterEvents();

      /* RE-INIT custom collection JS (sort + swatches) */
      try { if (typeof initCollectionCustomJS === 'function') initCollectionCustomJS(); } catch(e){ console.warn(e); }

      /* Rebind drawer open/close if you use that helper */
      try { if (typeof fixDrawerRebind === 'function') fixDrawerRebind(); } catch(e){/* optional */ }

    })
    .catch(err => {
      console.error('AJAX load error', err);
    });
}

document.addEventListener("change", function(e){
  if(e.target.id === "SortBy"){
    window.location.href = e.target.selectedOptions[0].dataset.url;
  }
});